"use strict";

const Cookies = require("js-cookie");

const isSafari = window.safari !== undefined;
const cookieOptions = {
  sameSite: "strict",
  secure: true,
  path: "/",
};

if (isSafari && CONFIGURATION && CONFIGURATION.debugOrTest) {
  delete cookieOptions["secure"];
}

const keyName = window.location.protocol === "https:" ? "__Host-hint.account_token" : "hint.account_token";

module.exports = {
  set: function (value) {
    return Cookies.set(keyName, value, cookieOptions);
  },

  get: function () {
    return Cookies.get(keyName);
  },

  remove: function () {
    Cookies.remove(keyName, cookieOptions);
  },
};
